import { Settings, Shield, Globe, HelpCircle, Download, Key, Mail, ChevronRight } from 'lucide-react';

interface SettingsItem {
  id: string;
  label: string;
  icon: any;
  value?: string;
  readOnly?: boolean;
  onClick?: () => void;
  helperText?: string;
}

interface SettingsGroupProps {
  title: string;
  items: SettingsItem[];
}

export const SettingsGroup = ({ title, items }: SettingsGroupProps) => {
  return (
    <div className="space-y-2">
      <h4 className="text-xs font-bold uppercase tracking-wider text-muted-foreground ml-2">
        {title}
      </h4>
      <div className="bg-card rounded-2xl shadow-card overflow-hidden">
        {items.map((item, index) => (
          <div key={item.id}>
            <button
              onClick={item.onClick}
              disabled={item.readOnly || !item.onClick}
              className={`w-full flex items-center justify-between p-4 bg-transparent text-left transition-colors
                ${!item.readOnly && item.onClick ? 'hover:bg-muted/30 cursor-pointer active:bg-muted/50' : 'cursor-default'}
              `}
            >
              <div className="flex items-center gap-3 min-w-0">
                <div className={`p-2 rounded-xl ${item.readOnly ? 'bg-muted text-muted-foreground' : 'bg-primary/5 text-primary'}`}>
                  <item.icon className="h-4 w-4" />
                </div>
                <div className="min-w-0">
                  <p className={`text-sm font-medium ${item.readOnly ? 'text-muted-foreground' : 'text-foreground'}`}>
                    {item.label}
                  </p>
                  {item.helperText && (
                    <p className="text-[10px] text-muted-foreground mt-0.5 truncate">
                      {item.helperText}
                    </p>
                  )}
                </div>
              </div>
              
              <div className="flex items-center gap-2 flex-shrink-0 ml-4">
                {item.value && (
                  <span className="text-xs text-muted-foreground max-w-[120px] truncate">
                    {item.value}
                  </span>
                )}
                {!item.readOnly && item.onClick && (
                  <ChevronRight className="h-4 w-4 text-muted-foreground/50" />
                )}
              </div>
            </button>
            {index < items.length - 1 && (
              <div className="h-px bg-border/50 ml-14" />
            )}
          </div>
        ))}
      </div>
    </div>
  );
};
